export const WITHDRAWAL_FORM_MESSAGE_VALIDATION_RULES = {
  withdrawalFormMessage: {
    isRequired: {
      value: true,
    },
  },
};

export const WITHDRAWAL_FORM_POPUP_VALIDATION_RULES = {
  withdrawalPopupTitle: {
    isRequired: {
      value: true,
    },
  },
  withdrawalPopupMessage: {
    isRequired: {
      value: true,
    },
  },
};

export const WITHDRAWAL_FORM_REDIRECT_BUTTON_MESSAGE_VALIDATION_RULES = {
  withdrawalRedirectButtonTitle: {
    isRequired: {
      value: true,
    },
  },
  withdrawalRedirectButtonValue: {
    isRequired: {
      value: true,
    },
  },
  withdrawalRedirectUrl: {
    isRequired: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/withdrawal-configuration/WithdrawalFormMessageValidationRules.js